import { css } from 'styled-components';

const Typhography = css`
  html {
    /* font-family: Pretendard, -apple-system, BlinkMacSystemFont, system-ui,
      Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo',
      'Noto Sans KR', 'Malgun Gothic', sans-serif; */
    font-family: var(--defaultFontFamily);
    font-size: var(--textSize);
    font-weight: 400;
    color: var(--textColor);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--headerFontFamily);
  }

  h1 {
    font-size: 56px;
    line-height: 1.35;
  }

  h2 {
    font-size: 48px;
    line-height: 1.3;
  }

  h3 {
    font-size: 42px;
    line-height: 1.35;
  }

  h4 {
    font-size: 28px;
    line-height: 1.4;
  }

  h5 {
    font-size: 24px;
    line-height: 1.2;
  }

  h6 {
    font-size: 20px;
    line-height: 1.35;
  }

  p {
    font-size: var(--textSize);
  }

  textarea {
    font-size: var(--textSize);
  }

  b {
    font-weight: 700;
  }

  strong {
    font-weight: 800;
  }

  small {
    font-size: 13px;
    line-height: 1.2;
  }

  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }

    p,
    textarea {
      font-size: 14px;
    }

    h1 {
      font-size: 46px;
    }

    h2 {
      font-size: 36px;
    }

    h3 {
      font-size: 32px;
    }

    h4 {
      font-size: 24px;
      line-height: 1.3;
    }

    h5 {
      font-size: 18px;
    }

    h6 {
      font-size: 16px;
    }
  }

  @media (max-width: 460px) {
    html {
      font-size: 14px;
    }

    p,
    textarea {
      font-size: 14px;
    }

    h1 {
      font-size: 34px;
    }

    h2 {
      font-size: 30px;
    }

    h3 {
      font-size: 28px;
    }

    h4 {
      font-size: 20px;
    }

    h5 {
      font-size: 18px;
    }

    h6 {
      font-size: 16px;
    }
  }
`;

export default Typhography;
